import { useQuery } from '@tanstack/react-query';
import { getSuppliers, type SuppliersResponse } from '../api';

/**
 * Hook to fetch available suppliers for complaint submission
 * @param enabled - Whether to fetch suppliers (default: true)
 */
export function useSuppliers(enabled = true) {
  return useQuery({
    queryKey: ['suppliers'],
    queryFn: async (): Promise<SuppliersResponse> => {
      return getSuppliers();
    },
    enabled,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes (suppliers rarely change)
  });
}
